var _path, _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeTrapeze6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 700,
    viewBox: "0 0 400 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 126H297.5V224.5L214 416.5V579H126V126Z",
    stroke: "white",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 126.775,
    y1: 580.861,
    x2: 211.775,
    y2: 414.861,
    stroke: "#A9A9A9",
    strokeWidth: 5,
    strokeDasharray: "10 10"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 297.777,
    y1: 229.857,
    x2: 351.777,
    y2: 124.857,
    stroke: "#A9A9A9",
    strokeWidth: 5,
    strokeDasharray: "10 10"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 296,
    y1: 126.5,
    x2: 353,
    y2: 126.5,
    stroke: "#A9A9A9",
    strokeWidth: 5,
    strokeDasharray: "10 10"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 136 116)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 224 569)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 224 406)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 307 218)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 307 116)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "matrix(-1 0 0 1 354 123)",
    fill: "#A9A9A9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 136 569)",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 126L97.6603 141L80.3397 141L89 126ZM89 579L80.3397 564L97.6602 564L89 579ZM90.5 139.5L90.5 565.5L87.5 565.5L87.5 139.5L90.5 139.5Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126 200L141 208.66V191.34L126 200ZM297 200L282 191.34V208.66L297 200ZM139.5 201.5H283.5V198.5H139.5V201.5Z",
    fill: "#929292"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.523 180V150.909H197.045V176.875H210.568V180H193.523ZM215.511 180V177.443L225.114 166.932C226.241 165.701 227.169 164.631 227.898 163.722C228.627 162.803 229.167 161.941 229.517 161.136C229.877 160.322 230.057 159.47 230.057 158.58C230.057 157.557 229.811 156.671 229.318 155.923C228.835 155.175 228.172 154.598 227.33 154.19C226.487 153.783 225.54 153.58 224.489 153.58C223.371 153.58 222.396 153.812 221.562 154.276C220.739 154.73 220.099 155.369 219.645 156.193C219.2 157.017 218.977 157.983 218.977 159.091H215.625C215.625 157.386 216.018 155.89 216.804 154.602C217.59 153.314 218.66 152.311 220.014 151.591C221.378 150.871 222.907 150.511 224.602 150.511C226.307 150.511 227.817 150.871 229.134 151.591C230.45 152.311 231.482 153.281 232.23 154.503C232.978 155.724 233.352 157.083 233.352 158.58C233.352 159.65 233.158 160.696 232.77 161.719C232.391 162.732 231.728 163.864 230.781 165.114C229.844 166.354 228.542 167.869 226.875 169.659L220.341 176.648V176.875H233.864V180H215.511Z",
    fill: "#929292"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126 90L141 81.3397V98.6603L126 90ZM351 90L336 98.6603V81.3397L351 90ZM139.5 88.5L337.5 88.5V91.5L139.5 91.5V88.5Z",
    fill: "#929292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.523 70V40.9091H231.045V66.875H244.568V70H227.523ZM257.903 40.9091V70H254.38V44.6023H254.21L247.107 49.3182V45.7386L254.38 40.9091H257.903Z",
    fill: "#929292"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126 615L141 606.34V623.66L126 615ZM214 615L199 623.66V606.34L214 615ZM139.5 613.5H200.5V616.5H139.5V613.5Z",
    fill: "#929292"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5227 365V335.909H53.0455V348.864H68.5568V335.909H72.0795V365H68.5568V351.989H53.0455V365H49.5227Z",
    fill: "#929292"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.523 668V638.909H155.045V664.875H168.568V668H151.523ZM183.341 668.398C181.466 668.398 179.795 668.076 178.327 667.432C176.868 666.788 175.708 665.893 174.847 664.747C173.994 663.592 173.53 662.252 173.455 660.727H177.034C177.11 661.665 177.432 662.474 178 663.156C178.568 663.829 179.312 664.349 180.23 664.719C181.149 665.088 182.167 665.273 183.284 665.273C184.534 665.273 185.642 665.055 186.608 664.619C187.574 664.184 188.331 663.578 188.881 662.801C189.43 662.025 189.705 661.125 189.705 660.102C189.705 659.032 189.439 658.09 188.909 657.276C188.379 656.452 187.602 655.808 186.58 655.344C185.557 654.88 184.307 654.648 182.83 654.648H180.5V651.523H182.83C183.985 651.523 184.998 651.314 185.869 650.898C186.75 650.481 187.437 649.894 187.929 649.136C188.431 648.379 188.682 647.489 188.682 646.466C188.682 645.481 188.464 644.624 188.028 643.895C187.593 643.166 186.977 642.598 186.182 642.19C185.396 641.783 184.468 641.58 183.398 641.58C182.394 641.58 181.447 641.764 180.557 642.134C179.676 642.493 178.956 643.019 178.398 643.71C177.839 644.392 177.536 645.216 177.489 646.182H174.08C174.136 644.657 174.596 643.322 175.457 642.176C176.319 641.021 177.446 640.121 178.838 639.477C180.24 638.833 181.778 638.511 183.455 638.511C185.254 638.511 186.797 638.876 188.085 639.605C189.373 640.325 190.363 641.277 191.054 642.46C191.745 643.644 192.091 644.922 192.091 646.295C192.091 647.934 191.66 649.33 190.798 650.486C189.946 651.641 188.786 652.441 187.318 652.886V653.114C189.155 653.417 190.59 654.198 191.622 655.457C192.654 656.707 193.17 658.256 193.17 660.102C193.17 661.684 192.74 663.104 191.878 664.364C191.026 665.614 189.861 666.598 188.384 667.318C186.906 668.038 185.225 668.398 183.341 668.398Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeTrapeze6);
export default __webpack_public_path__ + "static/media/node_trapeze_6.6b28da6a1a3f90e4c90db5e413859ebe.svg";
export { ForwardRef as ReactComponent };